import { Modal, Button, Table, Spinner, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const UserPermissionModal = ({ show, onClose, toolId, toolName, getData }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [removing, setRemoving] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    if (toolId) {
      fetchUsers();
    }
  }, [toolId]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredUsers(users);
    } else {
      const query = searchQuery.toLowerCase();
      setFilteredUsers(
        users.filter(
          (user) =>
            user.first_name?.toLowerCase().includes(query) ||
            user.lastname?.toLowerCase().includes(query) ||
            user.role_name?.toLowerCase().includes(query),
        ),
      );
    }
  }, [searchQuery, users]);

  const fetchUsers = () => {
    setLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/coursebuilder-access?tool_id=${toolId}`)
      .then((response) => {
        const userData = response.data.data || [];
        // console.log("Fetched users:", userData);
        setUsers(userData);
        setFilteredUsers(userData);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
        toast.error("Error fetching users");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleRemoveUser = (userId) => {
    // Real API call - Uncomment when backend is ready
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/coursebuilder-access`,
          { params: { user_id: userId, tool_id: toolId } }
      )
      .then(() => {
        toast.success("User removed successfully");
        fetchUsers();
        getData();
      })
      .catch((error) => {
        console.error("Error removing user:", error);
        toast.error("Error removing user");
      })
      .finally(() => {
        setRemoving(null);
      });
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="xl"
      centered
      style={{ zIndex: 10000 }}
      dialogClassName="modal-90w"
    >
      <Modal.Header closeButton>
        <Modal.Title>Users with Access - {toolName}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ overflowY: "auto", maxHeight: "500px" }}>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            <Form.Control
              type="text"
              placeholder="Search users by name or role..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="mb-3"
            />
            {filteredUsers.length > 0 ? (
              <div
                style={{
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  maxHeight: "400px",
                  overflowY: "auto",
                }}
              >
                <Table hover className="mb-0">
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>
                    <tr>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Role</th>
                      <th style={{ width: "80px", textAlign: "center" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUsers.map((user, index) => (
                      <tr key={user.user_id ? `${user.user_id}-${index}` : `user-${index}`}>
                        <td>{user.first_name}</td>
                        <td>{user.last_name}</td>
                        <td>{user.role_name}</td>
                        <td style={{ textAlign: "center" }}>
                          {removing === user.user_id ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            <img
                              src="/images/trash.svg"
                              alt="delete"
                              onClick={() => handleRemoveUser(user.user_id)}
                              style={{
                                cursor: "pointer",
                                width: "18px",
                                height: "18px",
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="mb-0">
                  {searchQuery.trim() !== ""
                    ? "No users found matching your search"
                    : "No users found with access for this module"}
                </p>
              </div>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserPermissionModal;
